export enum CommonEvents {
    ButtonPanel = 'common.buttonPanel',
    CacheReady = 'common.cachingReady',
    ChangeTitle = 'common.changeTitle',
    ConnectionStatus = 'common.connectionStatus',
    DashboardUpdate = 'dashboard.dashboardUpdate',
    SensorUpdate = 'dashboard.sensorUpdate',
    InsertToCache = 'cache.insertToCache',
    OpenSearchBar = 'common.openSearchBar',
    DashboardLocationLoading = 'dashboard.locationLoading',
    VisibleFavorite = 'common.VisibleFavorite',
    /**
     * Called in time dialog after input recieved correct value
     */
    NextInput = 'common.nextInput',
    ToggleFullscreen = 'common.toggleFullscreen',
    SizeChange = 'common.sizeChange'
}
